import { CheckoutStateEnum } from '@monofront/types';
import { ICheckoutMachineContext } from './types';

export const isAddressed = (context: ICheckoutMachineContext) =>
  context.checkoutCart?.checkoutState === CheckoutStateEnum.ADDRESSED;
export const isAddressSelected = (context: ICheckoutMachineContext) =>
  context.shippingAddressSelected != null &&
  context.billingAddressSelected != null;
export const isShippingSkipped = (context: ICheckoutMachineContext) =>
  context.checkoutCart?.checkoutState === CheckoutStateEnum.SHIPPING_SKIPPED;
export const isShippingMethodSelected = (context: ICheckoutMachineContext) =>
  context.checkoutCart?.checkoutState === CheckoutStateEnum.SHIPPING_SELECTED;
export const isDeliveryInfoUpdated = (
  context: ICheckoutMachineContext,
  event,
) =>
  context.shippingAddressSelected?.deliveryInstruction !==
  event.data.data.selectHomeShippingMethod?.shipments?.[0].deliveryInstruction;
export const isCheckoutCartReady = (context: ICheckoutMachineContext) =>
  context.checkoutCart != null;
export const isUserReady = (context: ICheckoutMachineContext) =>
  context.isUserReady;
